import { Dispatch, FC, SetStateAction } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import { TYPE_FILES_ALLOWED } from 'constants/defaultConstants';
import Button from 'modules/_shared/components/Buttons';
import UploadDocument, {
  UploadDocumentSizes,
} from 'modules/documents/components/UploadDocument';

type SendEmailFooterProps = {
  body: string;
  file: File | undefined;
  setFile: Dispatch<SetStateAction<File | undefined>>;
  hasRecipients: boolean;
  onSendEmail: () => void;
  onSendTestEmail: () => void;
  subject: string;
};

const SendEmailFooter: FC<SendEmailFooterProps> = ({
  body,
  file,
  setFile,
  hasRecipients,
  onSendEmail,
  onSendTestEmail,
  subject,
}) => {
  const { t } = useTranslate();

  const isSendTestEmailDisabled = !subject || !body;
  const isSendDisabled = !subject || !body || !hasRecipients;

  return (
    <div className="nk-reply-form-tools bg-light">
      <div className="nk-reply-form-actions d-flex justify-content-between align-items-center w-100">
        <div className="d-flex align-items-center flex-grow-1 mr-3">
          <UploadDocument
            accept={TYPE_FILES_ALLOWED}
            buttonClassName="btn-primary"
            file={file}
            mandatory={false}
            setFile={setFile}
            size={UploadDocumentSizes.SMALL}
          />
        </div>

        <Button
          className="mr-2"
          onClick={onSendTestEmail}
          disabled={isSendTestEmailDisabled}
          icon="ni ni-send"
          text={t('SendTestEmail')}
        />

        <Button
          onClick={onSendEmail}
          disabled={isSendDisabled}
          icon="ni ni-send"
          text={t('Send')}
        />
      </div>
    </div>
  );
};

export default SendEmailFooter;
